import {OnInit, Component, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import { PRODUCT_TS } from '../MainComponent';
import { TokenStorage } from 'providers/TokenStorage';

declare let userInterface:any;

@Component({
    selector: 'invalid-request',
    templateUrl: "../../../views/components/passwordRecovery/invalidRequest.html",
    providers: [],
    styleUrls: ["../../../styles/login.css"]
})
export class InvalidRequest implements OnInit {

    PRODUCT: any;
    
    userInterface:any=userInterface;

    constructor(private router: Router,
        private tokenStorage: TokenStorage) {
        this.PRODUCT = PRODUCT_TS;
    }

    ngOnInit() {
        let bg_login_class = {
            "background": `url(${this.PRODUCT.BACKGROUND_LOGIN}) no-repeat fixed center center`,
            "background-size": "cover",
            "background-attachment": "fixed"
        };
        $('.login-background').css(bg_login_class);
        this.tokenStorage.verifyCookieAndLocalStorage();
    }
}

@NgModule({
    declarations: [InvalidRequest],
    imports: [FormsModule, BrowserModule, RouterModule],
    providers: [],
    entryComponents: [],
    exports: []
})
export class InvalidRequestModule {
}